import { createApi } from "@reduxjs/toolkit/query/react"

import { ApiTypes } from "types"

import { baseQueryWithAuth } from "utils/api"

export const featureFlagsApi = createApi({
  reducerPath: "featureFlagsApi",
  baseQuery: baseQueryWithAuth,
  endpoints: builder => ({
    getFeatureFlags: builder.query<{ data: ApiTypes.Res.FeatureFlags }, void>({
      query: () => ({
        url: `/feature-flags`,
        method: "GET",
      }),
    }),
  }),
})

export const { useLazyGetFeatureFlagsQuery } = featureFlagsApi
